import { getRevenueCenterMenuUuids } from 'utils/menusDrawer/getRevenueCenterMenuUuids'

// return uuid of revenue center if at least one of his children
// is deselected
export const removeRevenueCenterUuid = (
  uuid,
  currentSelectedUuids,
  filteredMenusAndRevenueCenters
) => {
  // uuids of menus assigned to revenue center
  const revenueCenterMenusUuids = getRevenueCenterMenuUuids(
    filteredMenusAndRevenueCenters,
    uuid
  )

  if (
    !revenueCenterMenusUuids?.every((uuid) =>
      currentSelectedUuids?.includes(uuid)
    )
  ) {
    return uuid
  } else {
    return null
  }
}
